// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cald_home-page-container .sap-tag-line {
  font-family: "72-Black";
}

/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
.cald_home-page-container {
  font-family: "72-Regular";
}

.cald_home-page-container {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #edeff0;
  padding-bottom: 1.5rem;
}
.cald_home-page-container .cc_home-main-content .cald_home-header {
  padding: 2rem 2.7rem 2rem 2rem;
  background-color: #fff;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_user-image {
  margin-right: 1.2rem;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_user-image img {
  height: 4.8rem;
  width: 4.8rem;
  border-radius: 50%;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_user-image .cald_home-gender-img {
  border: 0.1rem solid #dfe3e4;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_user-image.cald_home-leader img {
  border: 0.1rem solid #f3bc44;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_home-header-text {
  color: #32363a;
  font-size: 1.6rem;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_home-header-group {
  color: #6f7275;
  font-size: 1.4rem;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_actions-icon {
  cursor: pointer;
  color: #0a6ed1;
}
.cald_home-page-container .cc_home-main-content .cald_home-header .cald_actions-icon em:before {
  font-size: 1.8rem;
}
.cald_home-page-container .cc_home-main-content .cald_home-cards-content {
  padding: 1.6rem 1.6rem 0rem;
}
.cald_home-page-container .sap-tag-line {
  display: inline-block;
  clear: both;
  color: #000;
  font-size: 1.1rem;
  text-transform: uppercase;
  position: fixed;
  bottom: 0;
  padding: 1rem;
  width: 100%;
  background-color: #edeff0;
}
.cald_home-page-container .sap-tag-line .cald_footer-sap-caption {
  position: absolute;
  top: 1.4rem;
}
.cald_home-page-container .sap-tag-line .cald_footer-sap-icon {
  margin-bottom: -0.6rem;
  margin-left: 8.6rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/components/home/home.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;ACCJ;;ADEA,gHAAA;AAqBA;EACI,yBAAA;ACnBJ;;AANA;EAEE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;AAQF;AANI;EAEE,8BAAA;EACA,sBAAA;AAON;AANM;EACE,oBAAA;AAQR;AAPQ;EACE,cAAA;EACA,aAAA;EACA,kBAAA;AASV;AAPQ;EACE,4BAAA;AASV;AAPQ;EACE,4BAAA;AASV;AANM;EACE,cAAA;EACA,iBAAA;AAQR;AANM;EACE,cAAA;EACA,iBAAA;AAQR;AANM;EACE,eAAA;EACA,cAAA;AAQR;AAPQ;EACE,iBAAA;AASV;AALI;EACM,2BAAA;AAOV;AAJE;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;AAMJ;AAJI;EACE,kBAAA;EACA,WAAA;AAMN;AAJI;EACE,sBAAA;EACA,mBAAA;AAMN","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import '../../assets/css/fonts';\n.cald_home-page-container {\n  @extend %font-regular;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #edeff0;\n  padding-bottom: 1.5rem;\n  .cc_home-main-content{\n    .cald_home-header {\n      // @extend %font-regular;\n      padding: 2rem 2.7rem 2rem 2rem;\n      background-color: #fff;\n      .cald_user-image {\n        margin-right: 1.2rem;\n        img {\n          height: 4.8rem;\n          width: 4.8rem;\n          border-radius: 50%;\n        }\n        .cald_home-gender-img{\n          border: 0.1rem solid #dfe3e4;\n        }\n        &.cald_home-leader img{\n          border: 0.1rem solid #f3bc44;\n        }\n      }\n      .cald_home-header-text {\n        color: #32363a;\n        font-size: 1.6rem;\n      }\n      .cald_home-header-group{\n        color: #6f7275;\n        font-size: 1.4rem;\n      }\n      .cald_actions-icon{\n        cursor: pointer;\n        color: #0a6ed1;\n        em:before{\n          font-size: 1.8rem;\n        }\n      }\n    }\n    .cald_home-cards-content{\n          padding: 1.6rem 1.6rem 0rem;\n    }\n  }\n  .sap-tag-line{\n    display: inline-block;\n    clear: both;\n    color: #000;\n    font-size: 1.1rem;\n    text-transform: uppercase;\n    position: fixed;\n    bottom: 0;\n    padding: 1rem;\n    width: 100%;\n    background-color: #edeff0;\n    @extend %font-black;\n    .cald_footer-sap-caption{\n      position: absolute;\n      top: 1.4rem;\n    }\n    .cald_footer-sap-icon{\n      margin-bottom: -0.6rem;\n      margin-left: 8.6rem;\n    }\n  }\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
